import { createContext } from 'react';

interface TrackingConsentContextType {
  trackingOptedIn: boolean;
}

const initialState: TrackingConsentContextType = {
  trackingOptedIn: false,
};

export const TrackingConsentContext = createContext<TrackingConsentContextType>(initialState);
